var canvas, canvas2, text, fontSize, fontFamily, fSize, activeCOLOR, newText, zoom, cWidth = 1000, cHeight = 1400,
    halfWidth = cWidth / 2, halfHeight = cHeight / 2,
    obj, array = [], get_data, sizeCrop,
    scale_factor, newheight, leftOb, imageUrl,
    placeholderimg1, placeholderimg2, placeholderimg3,
    placeholderimg4,img,
    leftMarker, rightMarker, vLine;

var loader = jQuery('#customLoader'),
    cropper = "", canvas, boxWidth, boxLeft, boxTop,
    croppedSize, orientations, aspectRatio, reCroper,
    c1img1;

var outLine,sizeBmW = 715, sizeBmH = 450,
    sizeB1W = 601, sizeB1H = 700,
    sizeB2W = 300, sizeB2H = 76;

imageUrl = document.getElementById('imageContainer').getAttribute('data-image-url');

$(document).ready(function() {

  currentImage = null; 

  function loadImage(url) {
    if (currentImage) {
      canvas2.remove(currentImage);
    }
    fabric.Image.fromURL(url, function(img) {
      img.set({
        left: halfWidth,
        top: halfHeight,
        selectable: false
      });
      // img.scale(.6);
      canvas2.add(img);
      currentImage = img; 
      img.sendToBack();
      // window['text1Page'].bringToFront();
      canvas2.renderAll();
    }, { crossOrigin: 'anonymous' });
  }

  var defaultUrl = $('#base1 img').attr('data-src');
  if(defaultUrl) {
    loadImage(defaultUrl);
  }

  
  // On style change
  jQuery(document).on('change', 'input[name="Style"]', function(e) {
    var selectedVal = $(this).val();

    if (selectedVal === 'Black Base (Big Size: Height 8 Width 5.5 inches)') {
      var blackUrl = $('#base1 img').attr('data-src');
      loadImage(blackUrl);
    } else {
      var woodenUrl = $('#base2 img').attr('data-src');
      loadImage(woodenUrl);
    }
  });

});


// let frameImg = document.querySelector("#lamp_border");
// let lampBorder = new fabric.Image(frameImg, {
//   left: 0,   
//   top: 0,
//   selectable: false
// });
// window['canvas2'] = new fabric.Canvas('canvas2', {
//   width: cWidth,
//   height: cHeight
// });

// window['canvas2'].add(lampBorder);
// addModify(window['canvas2']);




let frameImg = document.querySelector("#lamp_border");

// Initialize canvas2 if not already set
window['canvas2'] = new fabric.Canvas('canvas2', {
  width: cWidth,
  height: cHeight
});

let lampBorder;

// Load the image once and show it by default
fabric.Image.fromURL(frameImg.src, function(img) {
  lampBorder = img;
  lampBorder.set({
    left: halfWidth,
    top: halfHeight,
    scaleX: 1.363,
    scaleY: 1.363,
    selectable: false
  });

  // Add to canvas2 by default
  window['canvas2'].add(lampBorder);
  lampBorder.bringToFront();
  window['canvas2'].renderAll();

  // Handle select dropdown changes
  document.getElementById('lamp-border-select').addEventListener('change', function() {
    if (this.value === 'Yes') {
      if (!window['canvas2'].getObjects().includes(lampBorder)) {
        window['canvas2'].add(lampBorder);
        lampBorder.bringToFront();
      }
    } else {
      window['canvas2'].remove(lampBorder);
    }
    window['canvas2'].renderAll();
  });

}, { crossOrigin: 'anonymous' });

// Optional: apply any canvas modifications
addModify(window['canvas2']);




//-------------- Heart Calendar --------------

var inputDate = '2023-10-15',
  calendarGroup;


const cellWidth = 40;
const cellHeight = 29;
const startX = 40;
const startY = 140;


// Function to generate the calendar
document.getElementById('calendar-date').addEventListener('input', () => {
  const inputDate = document.getElementById('calendar-date').value;
  window['canvas2'].remove(calendarGroup);
  drawCalendar(inputDate);
});

function drawCalendar(inputDate) {
  if (!inputDate) {
    alert('Please select a date.');
    return;
  }

  const selectedDate = new Date(inputDate);
  const year = selectedDate.getFullYear();
  const month = selectedDate.getMonth();
  const selectedDay = selectedDate.getDate();

  calendarGroup = new fabric.Group([], {
    left: 0,
    top: 0,
    fill: 'rgba(0,0,0,0)',
    selectable: true
  });

  // Get the first and last days of the month
  const firstDay = new Date(year, month, 1);
  const lastDay = new Date(year, month + 1, 0);

  const firstDayOfWeek = firstDay.getDay();
  const totalDays = lastDay.getDate();

  // Format date as DD-MM-YYYY
  const day = String(selectedDay).padStart(2, '0');
  const formattedMonth = String(month + 1).padStart(2, '0');
  const formattedDate = `${day}/${formattedMonth}/${year}`;

  const monthYearTitle = new fabric.Text(
    formattedDate, {
      left: 175,
      top: 80,
      fontSize: 50,
      fontFamily: 'Galada',
      textAlign: 'center',
      originX: 'center',
      fill: '#000'
    }
  );

  calendarGroup.addWithUpdate(monthYearTitle);
  calendarGroup.left = 495;
  calendarGroup.top = 1110;
  window['canvas2'].add(calendarGroup);
  calendarGroup.bringToFront();
}

drawCalendar(inputDate);



window['placeholderimg1'] = new fabric.Rect({
  left: 501,
  top: 582,
  width: sizeB1W,
  height: sizeB1H,
  fill: 'rgba(0,0,0,0)'
});



window['canvas2'].add(window['placeholderimg1']);



var heartimg,heartBorder,imgRatio,clipRatio,clipWidth = 601;
    heartPathString = "M99.5,62.278h451v525.443h-451V62.278z";
var heartClip = new fabric.Path(heartPathString, {
  left: 501,
  top: 582,
  originX: 'center',
  originY: 'center',
  fill: 'transparent',
  absolutePositioned: true
});
heartClip.scaleToWidth(clipWidth);
canvas2.add(heartClip);

document.getElementById('image_upload_first').addEventListener('change',function(e){
  canvas = window['canvas2'];
  img = window['placeholderimg1'];
  available_height = img.height;
  sizeCrop = '0.86';
  reCroper = jQuery(this).parent().next().find('.btnReCrop').attr('data-height',available_height);
  readURL2(e.target, '#image1');
});


// Load the image and apply the clipPath
fabric.Image.fromURL('placeholder_lamp.png?v=1739800516', function(heartimg){
  heartimg.set({ crossOrigin: 'anonymous' });
  heartimg.set({
    left: 501,
    top: 582,
    originX: 'center',
    originY: 'center',
    selectable: false,
    clipPath: heartClip
  });
  // heartimg.scaleToWidth(clipWidth);
  canvas2.add(heartimg);
  canvas2.renderAll();
}, { crossOrigin: 'anonymous' });



window['text1Page'] = new fabric.Text('Happy Anniversary',{
  left: 490,
  top: 1010,
  fontSize: 70,
  fontFamily: 'Galada',
  fill: '#000',
  textAlign: 'left',
  originX: 'left',
  lockMovementX: true,
  lockMovementY: true,
  hasControls: false
});

var fontName = window['text1Page'].fontFamily;
jQuery('.choose_font').val("'" + fontName + "'").trigger('change');

// Add to canvas
window['canvas2'].add(window['text1Page']);

// Clear text on input focus if default
document.getElementById('text_1').addEventListener('focus', function () {
  if (window['text1Page'].text === 'Happy Anniversary') {
    window['text1Page'].set('text', '');
    window['canvas2'].renderAll();
  }
});

// Fit text within a specific width
function fitTextToWidth(textObj, maxWidth) {
  let fontSize = 70; // Start from larger size
  textObj.set({ fontSize });

  // Repeatedly shrink font until it fits
  while (textObj.width > maxWidth && fontSize > 5) {
    fontSize -= 1;
    textObj.set({ fontSize });
  }

  window['canvas2'].renderAll();
}

// Update text live and auto-fit width
document.getElementById('text_1').addEventListener('input', function (e) {
  const newText = e.target.value;
  window['text1Page'].set('text', newText);
  fitTextToWidth(window['text1Page'], 550); // ← adjust width as needed
  window['text1Page'].bringToFront();
  window['canvas2'].renderAll();
});



function canvasMakeImg(canvas,zoom){
  newZoomLevel = zoom / cWidth;
  setZoomMask(canvas,newZoomLevel);
}

function canvasBlock(canvas){
  zoom = jQuery('.product__media-outer').width();
  newZoomLevel = zoom / cWidth;
  setZoomMask(canvas,newZoomLevel);
}

function setZoomMask(canvas,newZoomLevel){
  canvas.setZoom(newZoomLevel);
  canvas.setDimensions({
    width:  cWidth * newZoomLevel,
    height:  cHeight * newZoomLevel
  });
  canvas.renderAll();
}

function addModify(canvas){
  fabric.Object.prototype.transparentCorners = false;
  fabric.textureSize = 75501472;75501472

  canvas.renderOnAddRemove = false;
  canvas.on('selection:cleared', function(e){
    object = e.target;
  });

  canvas.on('object:removed',function(e){
    object = e.target;
  });

  canvas.on('object:added', function(e){
    object = e.target;
    addControls(object);
    canvas.renderAll();
  });
  
  canvas.on('object:modified', function(e){
    object = e.target;
    canvas.renderAll();
  });
  
  canvas.on('selection:created', function(e){
    object = canvas.getActiveObject();
  });
  
  canvas.on('selection:updated', function(e){
    object = canvas.getActiveObject();
  });
  
  canvas.on('object:scaling', function(e){
    canvas.renderAll();
  });

  jQuery(window).on('load',function(){
    canvasBlock(canvas);
  });

  jQuery(window).on('resize',function(){
    canvasBlock(canvas);
  });
}

function addControls(object){
  var iconTL = document.createElement("img"),
      iconBR = document.createElement("img");
  
  iconTL.src = trashIcon;
  iconBR.src = resizeIcon;
  
  object.set({
    selectable:false,
    originX:"center",
    originY:"center",
    transparentCorners: false,
    borderColor: '#ddd',
    borderDashArray: [6,2],
    cornerStyle: 'circle',
    cornerColor: '#fff',
    objectCaching: false,
    _controlsVisibility: {
      tr: false,
      tl: true,
      bl: false,
      br: true,
      mb: false,
      ml: false,
      mr: false,
      mt: false,
      mtr: false
    }
  });
  
  iconTL.onload = function() {
    fabric.Object.prototype.controls.tl = new fabric.Control({
      x: -0.5,
      y: -0.5,
      offsetX: 0,
      offsetY: 0,
      cursorStyle: "pointer",
      mouseUpHandler: deleteHandler,
      render: renderIcon(iconTL),
      withConnection: true,
      cornerSize: 18,
    });
  };
  iconBR.onload = function() {
    fabric.Object.prototype.controls.br = new fabric.Control({
      x: 0.5,
      y: 0.5,
      offsetX: 0,
      offsetY: 0,
      cursorStyle: "se-resize",
      mouseUpHandler:fabric.controlsUtils.scalingEqually,
      render: renderIcon(iconBR),
      withConnection: true,
      cornerSize: 18,
    });
  }
}

function renderIcon(icon) {
  return function (ctx, left, top, styleOverride, fabricObject) {
    const size = this.cornerSize;
    ctx.save();
    ctx.translate(left, top);
    ctx.rotate(fabric.util.degreesToRadians(fabricObject.angle));
    ctx.drawImage(icon, -size / 2, -size / 2, size, size);
    ctx.restore();
  };
}

function deleteHandler(eventData,transform){
  var target = transform.target;
  activeOb = canvas.getActiveObject();
  canvas.remove(activeOb);
  canvas.renderAll();
}

initCropper();

function readURL2(input){
  loader.removeClass('hidden');
  jQuery('#tadaWidget').addClass('hidden');
  if(cropper == ""){
  }else {
    cropper.destroy();
  }
  if (input.files && input.files[0]) {
    var reader = new FileReader();
    reader.onload = function (e) {
      jQuery('#blah').attr('src', e.target.result);
      reCroper.attr('data-img',e.target.result);
    };
    reader.readAsDataURL(input.files[0]);
    setTimeout(initCropper, 2500);
  }
}

function addImage(e,placeholderimg,canvas){
  var file = e.target.files[0];
  var reader = new FileReader();
  reader.onload = function(event){
    var imgObj = new Image();
    imgObj.src = event.target.result;
    imgObj.onload = function(){
      var img = new fabric.Image(imgObj);
      img.set({
        left: placeholderimg.left,
        top: placeholderimg.top,
        selectable:true,
        scaleX: placeholderimg.width / img.width,
        scaleY: placeholderimg.height / img.height,
        clipPath: new fabric.Rect({
          width: img.width,
          height: img.height,
          rx: 20, // Apply border radius from placeholder
          ry: 20
        })
      });
    };
  };
  reader.readAsDataURL(file);
}

function addCroppedImg(imgurl) {
  const canvas = window['canvas2']; // ensure consistent canvas reference

  // Remove any previous temporary img var (if you used 'img' elsewhere)
  if (typeof img !== 'undefined' && canvas.getObjects().includes(img)) {
    canvas.remove(img);
  }

  // Remove previously added heart image (global)
  if (window['heartimg'] && canvas.getObjects().includes(window['heartimg'])) {
    canvas.remove(window['heartimg']);
  }

  // Load new image and save it to the global window['heartimg']
  fabric.Image.fromURL(imgurl, function(loadedImg) {
    loadedImg.set({ crossOrigin: 'anonymous' });

    // Position center (match your placeholder / clip coordinates)
    loadedImg.set({
      left: 501,
      top: 582,
      originX: 'center',
      originY: 'center',
      selectable: false
    });

    // Scale to target height (available_height) or width. Use whichever you need.
    // NOTE: available_height must be defined and numeric
    if (typeof available_height === 'number' && available_height > 0) {
      loadedImg.scaleToHeight(available_height);
    } else if (typeof sizeB1W === 'number' && sizeB1W > 0) {
      loadedImg.scaleToWidth(sizeB1W);
    }

    // Apply clip (heartClip should already exist in canvas)
    loadedImg.clipPath = heartClip;

    // Save as global so other functions can reference it
    window['heartimg'] = loadedImg;

    // Add to the same canvas
    canvas.add(window['heartimg']);

    canvas.renderAll();
  }, { crossOrigin: 'anonymous' });
}



function initCropper(){
  var image = document.getElementById('blah');
  cropper = new Cropper(image, {
    viewMode: 1,
    dragMode: 'move',
    aspectRatio: sizeCrop,
    restore: false,
    guides: false,
    center: true,
    highlight: true,
    cropBoxMovable: true,
    cropBoxResizable: true,
    toggleDragModeOnDblclick: false,
    data:{}
  });
  jQuery('.popupImg').show();
  jQuery('#tadaWidget').addClass('hidden');
  loader.addClass('hidden');
}

document.getElementById('crop_button').addEventListener('click', function(){
  loader.removeClass('hidden');
  jQuery('#tadaWidget').addClass('hidden');
  var imgurl =  cropper.getCroppedCanvas().toDataURL();
  addCroppedImg(imgurl);
  setTimeout(function(){
    reCroper.parent().removeClass('hidden');
    jQuery('.popupImg').hide();
    loader.addClass('hidden');
    jQuery('#tadaWidget').removeClass('hidden');
  },500);
});


document.getElementById('zoom_out').addEventListener('click', function(){
  cropper.zoom(-0.1);
});

document.getElementById('zoom_in').addEventListener('click', function(){
  cropper.zoom(0.1);
});

document.getElementById('reset_button').addEventListener('click', function(){
  cropper.reset();
});

document.getElementById('cancelCropper').addEventListener('click', function(){
  jQuery('.popupImg').hide();
  jQuery('#tadaWidget').removeClass('hidden');
});

jQuery(document).on('click','.btnReCrop', function(){
  loader.removeClass('hidden');
  imgurl = jQuery(this).attr('data-img');
  sizeCrop = jQuery(this).attr('data-ratio');
  img = window[jQuery(this).attr('data-obj')];
  canvas = window[jQuery(this).attr('data-canvas')];
  available_height = jQuery(this).attr('data-height');
  console.log(canvas);
  jQuery('#tadaWidget').addClass('hidden');
  setTimeout(function(){
    cropper.destroy();
    jQuery('#blah').attr('src',imgurl);
    initCropper();
    jQuery('.popupImg').show();
    loader.addClass('hidden');
  },150);
});

jQuery('.customColors').each(function(){
  colorBox = jQuery(this).attr('id');
  loadColorPicker(colorBox);
});

jQuery(document).on('change','.fontFamily',function(){
  var fontID = jQuery(this).attr('data-canvas');
  fontSize = '';
  activeCOLOR = '';
  fontFamily = jQuery(this).val();
  canvas = window[fontID];
  fitTextToWidth(window['text1Page'], 550);
});



function updateFont(activeOb,family,size,fill){
  if(activeOb){
    if(family == ''){
      family = activeOb.fontFamily;
    }
    if(size == ''){
      size = activeOb.fontSize;
    }
    if(fill == ''){
      fill = activeOb.fill;
    }
    sCAle = activeOb.scaleX;
    activeOb.set('fontSize',size);
    activeOb.set('fontFamily',family);
    activeOb.set('fill',fill);
    activeOb.scaleX = .5;
    activeOb.setCoords();
    canvas.renderAll();
    activeOb.scaleX = sCAle;
    activeOb.setCoords();
    canvas.renderAll();
  }
}

jQuery(document).on('click','.dropper-eyedrop',function(){
  const eyeDropper = new EyeDropper();
  eyeDropper.open().then(result => {
    jQuery(this).parent().parent().parent().colorpicker('setValue', result.sRGBHex);
  }).catch(e => {
    console.error(e);
  });
});


async function handleUpload(fileInputs,timeID){
  const temp_images = [];

  temp_images.push(jQuery('#crop_button').attr('data-cropped'));
  
  for (let input of fileInputs){
    const file = input.files[0]; // Only first file per input
    if(file){
      const base64 = await toBase64(file); // ✅ now safely inside async
      temp_images.push(base64);
    }
  }
  if(temp_images.length === 0){
    alert("Please select at least one image.");
    return;
  }
  const payload = {
    timeId: timeID,
    temp_images: temp_images
  };
  console.log(payload);
  try {
    const response = await fetch('//technology-architects.com/tasweer-modules/upload_client_img.php', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(payload)
    });
    
    const result = await response.json();
    console.log("Upload result:", result);
    var int = 1;
    result.uploaded_images.forEach(img => {
      if(jQuery('#image'+int).length < 1){
        jQuery('#preview').append('<input type="hidden" id="image'+int+'" name="properties[User Upload '+int+']">');
      }
      if (img.status === "success") {
        jQuery('#image'+int).val(img.image_url);
        int += 1;
      } else {
        console.warn("Upload failed:", img.error);
      }
    });
    jQuery('.product-form__buttons .product-form__submit').trigger('click');
    loader.addClass('hidden');
  } catch (error) {
    console.error("Upload error:", error);
    alert("Upload failed.");
  }
}

// ✅ Convert a file to base64 string
function toBase64(file){
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = () => resolve(reader.result);
    reader.onerror = error => reject(error);
  });
}


/* fetch Call */
var size,thumbnail;
var loadedObject,selectDate,enterTitle,borderLamp,chooseFont,additionalInfo,wMark,svgMrk;
let pdfData = {};
jQuery(document).on('click','#download',function(){
  loader.removeClass('hidden');
  setTimeout(function(){
    resizeObjects(window['canvas2']);
    const id = ['canvas2'];
    const canvas = window['canvas2'];
    size = 582;
    loadMark(id,canvas,size);
    size = 4000;
    removeMark(canvas,size);
    // hideExtras(canvas);
    canvas.remove(currentImage);
    window['canvas2'] = canvas.toDataURL('image/png');
    selectDate = jQuery('.calendar-date input').val();
    enterTitle = jQuery('.enter_title input').val();
    borderLamp = jQuery('.border_Lamp option:selected').val();
    chooseFont = jQuery('.choose_font option:selected').val();
    additionalInfo = jQuery('.tShirtImg textarea').val();
    // showExtras(canvas);
    canvasBlock(canvas);
    console.log(window['canvas2']);
    fetch('//technology-architects.com/tasweer-modules/save_order.php',{
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body:  JSON.stringify({
        temp_image: window['canvas2t'],
        original_image: window['canvas2']
      })
    })
    .then(response => response.json())
    .then(data => {
      console.log(data);
      var previewId = data[0],
          extraImg1 = data[1];
      jQuery('#previewImg').val(previewId);
      jQuery('#preExtraImg').val(extraImg1);
      jQuery('#selectDate').val(selectDate);
      jQuery('#enterTitle').val(enterTitle);
      jQuery('#borderLamp').val(borderLamp);
      jQuery('#chooseFont').val(chooseFont);
      jQuery('#addInfo').val(additionalInfo);
      console.log('Server response:', data);
      const fileInputs = document.querySelectorAll('.upload_image input[type="file"]');
      handleUpload(fileInputs,previewId);
    })
    .catch(error => console.error('Error uploading images:', error));
  },100);
});


function resizeObjects(canvas){
  if (window['placeholderimg1']) window['placeholderimg1'].setCoords();
  if (window['text1Page']) window['text1Page'].setCoords();
  if (typeof calendarGroup !== 'undefined') calendarGroup.setCoords();
  if (typeof lampBorder !== 'undefined') lampBorder.setCoords();
  if (typeof heartimg !== 'undefined') heartimg.setCoords();
  if (typeof heartClip !== 'undefined') heartClip.setCoords();
  if (typeof img !== 'undefined') img.setCoords();


  canvas.renderAll();

  var designResiz = new fabric.Group([window['placeholderimg1'],window['text1Page'],calendarGroup,lampBorder,img,heartimg,heartClip].filter(Boolean));

  designResiz.set({
    left: halfWidth,
    top: 735,
    originX: 'center',
    originY: 'center'
  });

  designResiz.scaleToWidth(1250);
  designResiz.setCoords();
  canvas.renderAll();
}


function loadMark(id,canvas,size){
  wMark = document.getElementById('wm_collage');
  svgMrk = wMark.innerHTML;
  fabric.loadSVGFromString(svgMrk, function(objects,options){
    loadedObject = fabric.util.groupSVGElements(objects, options);
    loadedObject.scaleToWidth(cWidth);
    loadedObject.set({
      left: cWidth / 2,
      top: cHeight / 2,
      originX: 'center',
      originY: 'center',
      objectCaching: false,
      selectable: false
    });
    canvas.add(loadedObject);
    loadedObject.bringToFront();
    loadedObject.setCoords();
    canvas.remove(currentImage);
    canvas.renderAll();
  });
  canvasMakeImg(canvas,size);
  window[id+'t'] = canvas.toDataURL('image/png');
  console.log(window[id+'t']);
}

function removeMark(canvas,size){
  canvas.remove(loadedObject).renderAll();
  canvasMakeImg(canvas,size);
}